import { pharmacyVerificationActions, pharmacyResendVerificationActions } from '../../../../actions/user/pharmacy/Account/verification';

const initialState = {
  isVerified: false,
  verificationStatus: null,
  loading: false,
  error: null,
  verificationEmailStatus: null,
  successMessage: null
};

const pharmacyVerificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case pharmacyVerificationActions.EMAIL.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case pharmacyVerificationActions.EMAIL.SUCCESS:
      return {
        ...state,
        isVerified: true,
        verificationStatus: action.payload,
        loading: false,
        error: null,
        successMessage: action.payload.message
      };
    case pharmacyVerificationActions.EMAIL.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case pharmacyVerificationActions.PHONE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null
      };

    case pharmacyVerificationActions.PHONE.SUCCESS:
      return {
        ...state,
        isVerified: true,
        verificationStatus: action.payload,
        loading: false,
        error: null,
        successMessage: action.payload?.message || 'Phone number verified successfully!'
      };

    case pharmacyVerificationActions.PHONE.FAILURE:
      return {
        ...state,
        isVerified: false,
        loading: false,
        error: action.error || 'Verification failed. Please try again.'
      };
    case pharmacyResendVerificationActions.RESEND_VERIFICATION_EMAIL.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        verificationEmailStatus: null
      };
    case pharmacyResendVerificationActions.RESEND_VERIFICATION_EMAIL.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        verificationEmailStatus: 'success',
        successMessage: action.payload.message
      };
    case pharmacyResendVerificationActions.RESEND_VERIFICATION_EMAIL.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        verificationEmailStatus: 'failed'
      };
    default:
      return state;
  }
};

export default pharmacyVerificationReducer;
